import CierreOrdenesInforme from "../componentes/CierreOrdenesInforme.vue";

const routes = [
    ...route("/cierre-ordenes", CierreOrdenesInforme, {
        Auth: true,
        ///req_admin: true
    }),
];

function route(path, component = Default, meta = {}) {
    return [
        {
            path,
            component,
            meta,
        },
    ];
}

export default routes;
